import type { TranslationTag } from '@ps/web-core-intl';
import React from 'react';

import { useRegulatoryIntl } from '@swf/core/hooks/useRegulatoryIntl';
import { Icon } from '@swf/sports/components';
import type { IconName } from '@swf/sports/types/icon';

import styles from './TitleIcon.scss';

interface TitleIconProps {
  name: IconName;
  text: TranslationTag;
}

export const TitleIcon: React.FC<TitleIconProps> = ({ name, text }) => {
  const { formatMessage } = useRegulatoryIntl();
  return (
    <span className={styles.featuredTitle}>
      <Icon name={name} label={formatMessage(text)} />
      <span className={styles.featuredTitleText}>{formatMessage(text)}</span>
    </span>
  );
};
